<div class="loader">
  <img src="assets/images/botshot-loader.gif" alt="loader" />
</div>
